/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-12 15:20:25
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-05-12 15:24:42
 * @FilePath: /unifyxp-v2-store-portal/src/pages/ProductEditor/Components/Image/Image1.tsx
 */
import React from 'react';
import css from './css.less';
import { Uploader } from '@/src/components';

import Row from '@/src/components/Layouts/Row/Row';
import _ from 'lodash';

const Images = (props) => {
  const { fileList, onChange, setFileList, className, disabled } = props;

  return (
    <Row
      elements={[
        {
          child: (
            <div className={`${css.container} ${className || ''}`}>
              <Uploader
                multiple={false}
                height={180}
                fileList={fileList}
                onChange={(imgArr = []) => {
                  setFileList(imgArr);
                  const _l = _.last(imgArr);
                  if (onChange) onChange(_l);
                }}
                disabled={disabled}
              />
            </div>
          ),
        },
      ]}
    />
  );
};
export default Images;
